'use strict';

var empty = '';
var hash = '#';
var hideAlert = 'd-none';
var showClass = 'd-block';
/**
 * Handle customer's actions on open / close Mirakl incidents per products
 */
/* Open the incident dialog listing the reasons and a textarea field for communication */
$('body').on('click', 'button.non-rb-return-button', function () {
    $('body').spinner().start();
    var $button = $(this);
    var $incidentDialog = $(hash + $button.data('dialog'));
    var $incidentAlert = $(hash + $button.data('alert'));
    var $incidentSuccess = $(hash + $button.data('success'));
    var errorMsg = $button.data('error');
    var errorLoginMsg = $button.data('errorlogin');

    $.ajax({
        url: $(this).data('url'),
        type: 'get',
        data: {
            open: $button.data('open')
        },
        success: function (data) {
            $incidentSuccess.addClass(hideAlert).html(empty);
            if (data && data.success) {
                $incidentAlert.addClass(hideAlert).html(empty); // clear out any errors
                var options = [];
                options.push('<option value="', '', '">', '', '</option>');
                $.each(data.message, function (index, value) {
                    options.push('<option value="', value.code, '">', value.label, '</option>');
                });
                $incidentDialog.find('.mirakl-reason-select').html(options.join('')); // populate the select box
                $incidentDialog.modal('show'); // open the dialog
            } else if (data && data.message) {
                $incidentAlert.removeClass(hideAlert).html(data.message); // show an error
            } else {
                $incidentAlert.removeClass(hideAlert).html(errorLoginMsg); // show an error
            }
            $('body').spinner().stop();
        },
        error: function () {
            $incidentSuccess.addClass(hideAlert).html(empty);
            $incidentAlert.removeClass(hideAlert).html(errorMsg); // show an error
            $('body').spinner().stop();
        }
    });
});

/* Close the dialog, submit customer feedback and show a success or fail message  */
$('body').on('click', 'button.mirakl-incident-submit-button', function () {
    var $submit = $(this);
    var $form = $(hash + $submit.data('formid'));

    var $incidentDialog = $(hash + $form.data('dialog'));
    var $incidentAlert = $(hash + $form.data('alert'));
    var $incidentSuccess = $(hash + $form.data('success'));
    var $incidentWarn = $(hash + $form.data('warn'));
    var errorMsg = $form.data('error');
    var $message = $form.find('textarea:input[name=message]');
    var $returnmessage = $form.find('select:input[name=reason]');
    var thread = $.trim($message.val());
    if (thread.length > 0 && (thread.length < $message.attr('minlength') || thread.length > $message.attr('maxlength'))) {
        $message.siblings('div.invalid-feedback').addClass(showClass).html($message.data('error'));
        return false;
    }

    var isValid = true;
    $form.find('textarea, .mirakl-reason-select').each((idx, formEl) => {
        var $formEl = $(formEl);
        if (!!$formEl.attr('required') && $formEl.val() === '') {
            $formEl.addClass('is-invalid');
            $formEl.next().removeClass('d-none');
            isValid = false;
        } else {
            $formEl.removeClass('is-invalid');
            $formEl.next().addClass('d-none');
        }
    });
    if (!isValid) {
        $message.siblings('div.invalid-feedback').addClass(showClass).html($message.data('missing-error'));
        $returnmessage.siblings('div.invalid-feedback').addClass(showClass).html($returnmessage.data('missing-error'));
        return false;
    }
    
    $message.siblings('div.invalid-feedback').removeClass(showClass).html(empty);

    $incidentDialog.modal('hide'); // close the dialog
    $form.spinner().start();
    $.ajax({
        url: $form.prop('action'),
        type: 'post',
        data: $form.serialize(),
        success: function (data) {
            if (data && data.success) {
                $incidentAlert.addClass(hideAlert).html(empty); // clear out any errors
                if (data.warn) {
                    $incidentSuccess.addClass(hideAlert).html(empty);
                    $incidentWarn.removeClass(hideAlert).html(data.message); // show an warn message
                } else {
                    $incidentWarn.addClass(hideAlert).html(empty);
                    $incidentSuccess.removeClass(hideAlert).html(data.message); // show the success message
                }
                $(hash + $form.data('submit')).hide(); // hide the submit button
                $('.start-a-return-button').hide();
            } else {
                $incidentAlert.removeClass(hideAlert).html(data.message); // show an error
            }
            $form.spinner().stop();
        },
        error: function () {
            $incidentAlert.removeClass(hideAlert).html(errorMsg); // show an error
            $form.spinner().stop();
        }
    });

    return true;
});
